import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Card({ children, className = '', ...props }) {
    return (_jsx("section", { className: `pm-card ${className}`.trim(), ...props, children: children }));
}
export function Button({ children, className = '', type = 'button', ...props }) {
    return (_jsx("button", { type: type, className: `pm-button ${className}`.trim(), ...props, children: children }));
}
export function StatusPill({ status, showSymbol = true, children, }) {
    const symbol = { healthy: '✓', at_risk: '!', critical: '×', unknown: '?' }[status];
    return (_jsxs("span", { className: `pm-status pm-status--${status}`, children: [showSymbol && _jsx("span", { "aria-hidden": "true", children: symbol }), children] }));
}
export function Switch({ checked, onLabel, offLabel, className = '', ...props }) {
    return (_jsxs("label", { className: `pm-switch ${className}`.trim(), children: [_jsx("input", { type: "checkbox", role: "switch", checked: checked, ...props }), _jsx("span", { className: "pm-switch__track", "aria-hidden": "true", children: _jsx("span", { className: "pm-switch__thumb" }) }), _jsx("span", { className: "pm-switch__label", children: checked ? onLabel : offLabel })] }));
}
//# sourceMappingURL=index.js.map